import angular from 'angular';
import { ibCCalculatePointsService } from 'ib-web-commons/app/core/http-services/prlm-pc/ib-calculate-points-service';


const controllerInfo = {
    module: 'ib-ancillaries-modal-module',
    inject: ['object', '$uibModalInstance', 'ibCCalculatePointsService', 'AncillariesConstants', 'localStorageService'],
    required: []
};

export class AviosAccumulatedController implements ng.IController {
    public model: any;
    private passengers: any;
    public ancillaries: AncillariesModel.AviosAncillariesResponseWithName;
    public loading = true;
    public serviceError = false;
    public types: any = {};
    public flowApp = this.localStorageService.get('flowApp');
    constructor (
        private object: any,
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        private ibCCalculatePointsService: ibCCalculatePointsService,
        private AncillariesConstants: AncillariesConstant,
        private localStorageService
    ) {
        this.model = object.modelObject.aviosAncillariesReq;
        this.passengers = object.modelObject.passenger;
    }

    /**
     * Initialize modal controller
     */
    $onInit (): void {
        this.ibCCalculatePointsService
            .getCalculateAviosAncillaries(this.object.modelObject.aviosAncillariesReq)
            .then((response: any) => {
                this.ancillaries = this.buildPassengers(response, this.object.modelObject.passenger);
                this.loading = false;
            })
            .catch((error: any) => {
                this.serviceError = true;
                this.loading = false;
            });
    }

    /**
     *
     * @param resp response servicece. model-> AncillariesModel.AviosAncillariesResponse
     * @param passengers data info passenger
     * @returns ancillaries transform. model-> AncillariesModel.AviosAncillariesResponseWithName
     */
    buildPassengers = (resp, passengers): AncillariesModel.AviosAncillariesResponseWithName => {
        if(this.flowApp === 'CKI') {
            passengers = this.transformId(this.passengers);
        }

        return {
            passengers: resp.passengers.map((passenger) => {
                return {
                    id: passenger.id,
                    name: passengers.passengers?.find((pass) => pass.passengerId === passenger.id).personalInfo.name,
                    surname: passengers.passengers?.find((pass) => pass.passengerId === passenger.id).personalInfo.surname,
                    ancillaries: passenger.ancillaries?.map((ancillary) => ({
                        title: this.AncillariesConstants.ANCILLARIES_LITERALS[ancillary.subType || ancillary.type] || ancillary.subType || ancillary.type,
                        aviosAmount: ancillary.monetaryAmount.find((item) => item.currency.code === 'AVIOS')?.amount,
                        pointsAmount: ancillary.monetaryAmount.find((item) => item.currency.code === 'POINT_TYPES')?.amount
                    }))
                };
            }),
            currency: resp.currency,
            flight: resp.flight,
            totalMonetaryAmount: resp.totalMonetaryAmount
        };
    };

    /**
     * transforma la id del passajero de (number) a (type_number)
     * @param passengers
     * @returns
     */
    transformId = (passengers) =>{
        return {
            ...passengers,
            passengers: passengers.passengers.map((passenger) => ({
                passengerId: passenger.type > 10 ? passenger.type : passenger.type + '_' + '0' + passenger.id,
                personalInfo: {...passenger}
            }))
        };

    };

    /**
     * Close modal
     */
    close = (): void => {
        this.$uibModalInstance.dismiss();
    };
}


try {
    AviosAccumulatedController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(AviosAccumulatedController.name, AviosAccumulatedController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    AviosAccumulatedController.$inject = controllerInfo.inject;
    mod.controller(AviosAccumulatedController.name, AviosAccumulatedController);
}
